/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_IntroInputs */

const en_gc_search_guides_gridcraft_online_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft online runs the spreadsheet editor in your browser. Start with a sample or open a local workbook, make a change, then save a downloaded copy before leaving. The link to the editor opens the app; it does not contain your workbook or synchronize your edits to another device.`)
};

const zh_gc_search_guides_gridcraft_online_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 在线版在浏览器中运行电子表格编辑器。你可以从示例开始，也可以打开本地工作簿，修改后应在离开前下载保存。编辑器链接只是应用入口，不包含你的工作簿，也不会将修改同步到其他设备。`)
};

/**
* | output |
* | --- |
* | "GridCraft online runs the spreadsheet editor in your browser. Start with a sample or open a local workbook, make a change, then save a downloaded copy before..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_intro = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_intro(inputs)
	return zh_gc_search_guides_gridcraft_online_intro(inputs)
});
export { gc_search_guides_gridcraft_online_intro as "gc.search_guides.gridcraft_online.intro" }